// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.scheduled_action_status_enum */
var ScheduledActionStatusEnum;
(function (ScheduledActionStatusEnum) {
    ScheduledActionStatusEnum["SCHEDULED"] = "SCHEDULED";
    ScheduledActionStatusEnum["COMPLETED"] = "COMPLETED";
    ScheduledActionStatusEnum["CANCELLED"] = "CANCELLED";
})(ScheduledActionStatusEnum || (ScheduledActionStatusEnum = {}));
;
export default ScheduledActionStatusEnum;
/** Zod schema for scheduled_action_status_enum */
export const scheduledActionStatusEnum = z.nativeEnum(ScheduledActionStatusEnum);
//# sourceMappingURL=ScheduledActionStatusEnum.js.map